export function sortArray<T>(array: T[], compareFn: (a: T, b: T) => number) {
  array = [...array];
  array.sort(compareFn);
  return array;
}
